import { useNavigate, useParams } from "react-router-dom";

export function withHooks(Component){
    return props => {
        const navigate = useNavigate();
        const params = useParams();
        return <Component {...props} navigate={navigate} params={useParams()} />
    }
    
}